export const GET_BANK_ACCOUNTS = 'app/BankAccount/GET_BANK_ACCOUNTS'
export const GET_BANK_ACCOUNTS_ERROR = 'app/BankAccount/GET_BANK_ACCOUNTS_ERROR'
export const GET_BANK_ACCOUNTS_SUCCESS =
  'app/BankAccount/GET_BANK_ACCOUNTS_SUCCESS'
export const SAVE_BANK_ACCOUNTS = 'app/BankAccount/SAVE_BANK_ACCOUNTS'
export const SAVE_BANK_ACCOUNTS_ERROR =
  'app/BankAccount/SAVE_BANK_ACCOUNTS_ERROR'
export const SAVE_BANK_ACCOUNTS_SUCCESS =
  'app/BankAccount/SAVE_BANK_ACCOUNTS_SUCCESS'
